(function () {
    'use strict';

    run.pages.home = function() {
    };
})();